






















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import { userModule } from "@/store/modules/user";

@Component
export default class ListPerencanaanMpp extends Vue {
  @Prop({ default: () => [] }) items!: any[];
  @Prop({ default: "300px" }) height!: string;
  @Prop({ type: Boolean, default: false }) isReadonly!: boolean;

  get headers() {
    const allHeaders = [
      { text: "No", value: "no", sortable: false, width: "3%" },
      {
        text: "Tanggal / Ruang / Petugas",
        value: "info_gabungan",
        sortable: false,
        width: "16%"
      },
      {
        text: "Asesmen",
        value: "asesmen",
        sortable: false,
        width: "33%"
      },
      {
        text: "Perencanaan",
        value: "rencana",
        sortable: false
      },
      {
        text: "Aksi",
        value: "aksi",
        sortable: false,
        width: "2%",
        align: "center"
      }
    ];

    if (this.isReadonly) {
      return allHeaders.filter(h => h.value !== "aksi");
    }

    return allHeaders;
  }

  formatTanggal(authored_at: string) {
    if (!authored_at) return "-";
    return moment(authored_at).format("DD-MM-YYYY HH:mm");
  }

  get sortedItems() {
    return [...this.items].sort((a, b) => {
      const dateA = new Date(a.authored_at).getTime();
      const dateB = new Date(b.authored_at).getTime();
      return dateB - dateA; // Descending (Terbaru di atas)
    });
  }

  getValidRencana(item: any) {
    if (!item || !item.content) return [];

    // content lama = array; content baru = objek { nama_perawat, rencana: [] }
    const list = Array.isArray(item.content)
      ? item.content
      : item.content.rencana || [];

    // Filter hanya namaAspek yang memiliki isi di asesmen ATAU di plan
    return list.filter((ren: any) => {
      const hasAsesmen = ren.asesmen && ren.asesmen.length > 0;
      const hasPlan = ren.plan && ren.plan.length > 0;
      return hasAsesmen || hasPlan;
    });
  }

  getNamaPerawat(item: any) {
    if (!item || !item.content || Array.isArray(item.content)) return "";
    return item.content.nama_perawat || "";
  }

  sortById(data: any[]) {
    if (!data) return [];
    return [...data].sort((a, b) => {
      return parseInt(a.id) - parseInt(b.id);
    });
  }

  get stateUser() {
    return userModule.user;
  }

  isRowReadonly(item: any): boolean {
    if (this.isReadonly) return true;

    if (!this.stateUser) return true;

    const isOwner = Number(item.user_id) === Number(this.stateUser.id);
    const isSameUnit = String(item.unit_id) === String(this.stateUser.unit_id);

    return !(isOwner && isSameUnit);
  }
}
